import { Analytics } from './analytics';
import { AddRecommendationItemAction } from '../../../search/addRecommendationItem/actions/add_recommendation_item_action';

export class AddRecommendationItemFinishAnalytics extends Analytics {
    constructor() {
        super();

        AddRecommendationItemAction.ADD_RECOMMENDATION_ITEM_FINISH_EVENT.on((data) => {
            this.run(() => {
                const item = data.analyticsData.items[0];
                const addRecommendationItemFinishData = {
                    server: 'club/pc',
                    fName: '推奨品登録完了',
                    events: ['event271'],
                    items: [this.items(item.getProductName())],
                    soloel: {
                        server: 'club/pc',
                        prop5: '推奨品登録完了',
                        events: ['event64'],
                        products: [this.items(item.getProductNameForSoloel())],
                    },
                };
                window.sc_trackLinkAll(addRecommendationItemFinishData, data.target, 'o', 'AddFinRecomProd');
            });
        });
    }

    private items(productName: string) {
        return {
          category: '',
          productName: productName,
          quantity: '',
          price: '',
          events: [],
          evars: {},
        };
      }
}
